import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';

import { Theme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useCompanyQuery } from '../../../../../../graphql/query/company/useCompanyQuery';
import CircularProgress from '../../../../../components/_loading/CircularProgress';
import NotFound from '../../../../../components/_error/NotFound';
import ProductLayout from '../../../../../layout/Product';
import useRouter from '../../../../../components/_hook/useRouter';
import useRoutes from '../../../../../components/_hook/useRoutes';
import DropshipedRequestForDropshipDetailDisabled from './DropshipedRequestForDropshipDetailDisabled';
import DropshipedRequestForDropshipDetailTable from './DropshipedRequestForDropshipDetailTable';
import Helmet from '../../../../../components/Helmet';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  containerBackButton: { marginTop: theme.spacing(1) },
  rootPaper: { paddingBottom: theme.spacing(2) },
}));

function DropshipedRequestForDropshipDetail() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { params } = useRouter();
  const { path } = useRoutes();
  const { companyID, toCompanyID } = params;

  const { data, loading } = useCompanyQuery(
    `
    _id
    settings {
      enableDropshipping
    }
  `,
    {
      variables: {
        filter: {
          _id: toCompanyID as string,
        },
        limit: 1,
      },
    }
  );

  const toCompany = data ? data.companies.items[0] : null;

  if (loading) return <CircularProgress center color="primary" />;
  if (!toCompany) return <NotFound />;
  const isTargetCompanyEnableDropshipping = Boolean(
    toCompany && toCompany.settings && toCompany.settings.enableDropshipping
  );

  return (
    <>
      <Helmet
        title={`${t('request_for_dropship', { count: 2 })} | ${t('product')}`}
      />
      <Grid container>
        <Grid item xs={12} className={classes.containerBackButton}>
          <Button
            color="primary"
            variant="contained"
            component={Link}
            to={path('product.dropshipped.request', {
              companyID,
            })}
            startIcon={<ArrowBackIosIcon />}
          >
            {t('back')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          {isTargetCompanyEnableDropshipping ? (
            <DropshipedRequestForDropshipDetailTable />
          ) : (
            <DropshipedRequestForDropshipDetailDisabled />
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default () => (
  <ProductLayout main={<DropshipedRequestForDropshipDetail />} />
);
